import {makeStyles} from "@material-ui/core/styles";

const StyleScoreView = makeStyles(theme => ({
    retake_button: {
        textTransform: 'none',
        margin: theme.spacing(2, 0, 0),
        borderRadius: 0,
    },
    scoreView: {
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        padding : 10,
        paddingBottom: 20
    },
    imageScoreView: {
        display: "flex",
        marginBottom: 25,
        justifyContent: "center"
    },
    contentScoreView: {
        display: "flex",
        flexDirection: "column",
        marginBottom: 70,
        paddingLeft: 15,
        paddingRight: 15
    },
    scoreAgain : {

    },
    buttonRetakeQuiz: {
        backgroundColor: '#5e48ce',
        color: '#fff',
        width: '315px',
        height: '42px',
        borderRadius: '50px'
    },
    noResult: {
        position: 'absolute',
        top: "50%",
        left: "50%",
        transform: 'translate(-50%, -50%)',
        width: "100%",
        textAlign: "center"
    }
}));

export default StyleScoreView;